import { useCallback } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import Task106Game from './game';
import './style.scss';

type Props = {
    onComplete?: () => void
}

const Task106: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-106');

    return <div className="task task-106">
        <h2>zadanie 6</h2>
        <h3>{task?.title}</h3>
        <p>Co dla Was oznacza zdrowie?</p>
        <p className="instruction">
            <strong>Zadanie:</strong> Dopasujcie cytaty do właściwych autorów.
        </p>
        <Task106Game onComplete={onComplete} />
    </div>
}


export default Task106;
